// removed by extract-text-webpack-plugin
module.exports = {"bubbleCircle":"P8IqG2WsRtfSvy5DX3p0n","clickMessage":"_1J1kuOo1m1MmrcnI9BMcC6","nameDidIt":"Fwp8ZWWdXSEp1iM93pmia","personField":"_2wWWIW6g7dXOy8Na26FudP"};


//////////////////
// WEBPACK FOOTER
// ./src/componentStyles/ChoreBubble.css
// module id = 384
// module chunks = 0